import { cn } from "@/libraries/cn";
import type React from "react";
import { forwardRef } from "react";

type SkeletonProps = React.ComponentProps<"div">;

const Skeleton = forwardRef<HTMLDivElement, SkeletonProps>(
	({ className, ...props }, ref) => {
		return (
			<div
				ref={ref}
				className={cn("animate-pulse rounded-md bg-gray-300", className)}
				{...props}
			/>
		);
	},
);

export default Skeleton;
